<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/sonoma/ridge-vineyards')">Ridge Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/sonoma/sine-qua-non')">Sine Qua Non
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/sonoma/verite-vigneron')">Verite Vigneron
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Sonoma</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Napa potrebbe essere la valle della California che attira i titoli dei giornali, ma sarebbe negligente ignorare Sonoma
                        County durante lo sviluppo del tuo portafoglio di vini pregiati. Situato a circa un'ora a nord di San Francisco,
                        Il vasto e variegato terreno di Sonoma può significare solo cose buone per l'enologo più intimo. Con 17
                        Aree viticole americane (AVA) che si estendono per 20 miglia, le valli di Sonoma e
                        microclimi significa che è possibile sorseggiare un rosé a casa di un vignaiolo hipster, degustare un
                        Zinfandel durante un tour del magazzino di produzione, assaggia lo Chardonnay direttamente dalla botte in un
                        grotta sotterranea o goditi i Pinot durante una degustazione verticale privata.
                        <br><br>
                        Situata tra l'Oceano Pacifico e Napa, Sonoma produce silenziosamente quasi il doppio del vino
                        come Napa, eppure non genera nemmeno la metà dei pollici di colonna. Mentre non ci sono grandi biglietti
                        aziende vinicole qui, ciò che Sonoma fa incredibilmente bene è produrre un livello costante di eccellente
                        vino rosso corposo. Temperato e il clima varia dalle pianure battute dal sole alle colline cariche di nebbia,
                        che rappresenta la gamma di vini disponibili sul mercato secondario o con la tua multa
                        rivenditore di vino.
                        <br><br>
                        Fondata dai frati francescani durante una missione nel 1823, l'industria vinicola della contea di Sonoma era
                        originariamente destinato al vino della comunione. Subendo la stessa sorte dei suoi vicini di Napa durante
                        All'inizio del XX secolo, la produzione vinicola della regione è scesa a meno di 50 aziende vinicole. Sonoma lo era
                        più lento a raccogliere il guanto di sfida lanciato da Mondovì e altri dopo il proibizionismo e persino fino a tardi
                        1960, c'erano meno di 50 km2 di vigneto piantato nella valle. Tuttavia, come consumo di vino
                        è cresciuto negli anni '70, così come i viticoltori intraprendenti e nel 1999 Sonoma Country contava 180 vini registrati
                        cantine. Nel 2019 quella cifra era di 250, oltre la metà dei quali sono stati stabiliti nell'ultimo
                        25 anni.
                        <br><br>
                        Tuttavia, i devastanti incendi boschivi nell'autunno del 2017 hanno colpito molte tenute e vigneti
                        sparire completamente. Spinte da venti a 60 mph, le fiamme hanno inghiottito più di 2450.000 acri di
                        terra e ha causato 43 vittime. 1.200 cantine sono state danneggiate (anche se solo meno di dieci gravemente) che
                        significa una produzione ridotta per gli anni a venire. Il fumo, ovviamente, influenzerà altri
                        Cantine californiane, indipendentemente dal fatto che siano state danneggiate o meno dagli incendi. Parecchi
                        I vigneti della contea di Sonoma, tra cui Ancient Oak Cellars e Helena View Johnson, sono stati colpiti duramente,
                        peggio della vicina Napa (sebbene Stag's Leap ne sia stata colpita), principalmente a causa della maggiore umidità di Napa
                        terreno che rendeva difficile l'adesione delle fiamme.
                        <br><br>
                        La ricostruzione è stata un processo arduo per le cantine, molte delle quali hanno perso la casa nel processo.
                        Tuttavia, quasi due anni dopo e lentamente ma inesorabilmente le cantine si stanno rimettendo in piedi.
                        Alcuni hanno continuato a produrre con uva acquistata e mentre altri stanno celebrando l'anno
                        con cuvée speciali che, sospettiamo, si riveleranno molto amichevoli per gli investitori negli anni a
                        Venire.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Sonoma</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Napa ist vielleicht das Tal Kaliforniens, das für Schlagzeilen sorgt, aber Sie sollten Sonoma nicht ignorieren
                        County bei der Entwicklung Ihres Portfolios erlesener Weine. Etwa eine Stunde nördlich von San Francisco gelegen,
                        Das weite und abwechslungsreiche Gelände von Sonoma kann für den heimlichen Önologen nur Gutes bedeuten. Mit 17
                        Amerikanische Weinbaugebiete (AVAs), die sich über 20 Meilen erstrecken, die Täler von Sonoma und
                        Dank des Mikroklimas ist es möglich, bei einem Hipster-Winzer zu Hause einen Rosé zu schlürfen, einen zu probieren
                        Probieren Sie Zinfandel während einer Tour durch das Produktionslager Chardonnay direkt aus dem Fass in einem
                        Besuchen Sie die unterirdische Höhle oder genießen Sie Pinots bei einer privaten vertikalen Verkostung.
                        <br><br>
                        Sonoma liegt zwischen dem Pazifischen Ozean und Napa und produziert stillschweigend fast doppelt so viel Wein
                        wie Napa, erzeugt jedoch nicht einmal halb so viele Spaltenzoll. Zwar gibt es kein großes Ticket
                        Den Weingütern hier gelingt es Sonoma unglaublich gut, ein konstantes Niveau an Exzellenz zu produzieren
                        vollmundiger Rotwein. Das gemäßigte Klima variiert von sonnenverwöhnten Ebenen bis hin zu nebelverhangenen Hügeln.
                        was das Spektrum der auf dem Zweitmarkt oder bei Ihnen erhältlichen Weine ausmacht
                        Weinhändler.
                        <br><br>
                        Die Weinindustrie im Sonoma County wurde 1823 von Franziskanermönchen während einer Mission gegründet
                        ursprünglich für den Kommunionwein bestimmt. Erleidet das gleiche Schicksal wie seine Nachbarn in Napa
                        Zu Beginn des 20. Jahrhunderts schrumpfte die Weinproduktion in der Region auf weniger als 50 Weingüter. Sonoma war
                        Nach der Prohibition und sogar noch später wird es langsamer, den von Mondovi et al. auferlegten Fehdehandschuh aufzunehmen
                        1960 gab es im Tal weniger als 50 km² bepflanzte Weinberge. Allerdings als Weinkonsum
                        In den 1970er Jahren wuchs die Zahl der unternehmungslustigen Winzer, und 1999 waren in Sonoma Country bereits 180 Winzer registriert
                        Weingüter. Im Jahr 2019 lag diese Zahl bei 250, mehr als die Hälfte davon wurde erst kürzlich gegründet
                        25 Jahre.
                        <br><br>
                        Doch im Herbst 2017 kam es zu verheerenden Waldbränden, die zahlreiche Weingüter und Weinberge zerstörten
                        völlig verschwinden. Angetrieben durch Windgeschwindigkeiten von 60 Meilen pro Stunde vernichteten die Flammen mehr als 2.450.000 Hektar Land
                        Land und forderte 43 Todesopfer. 1.200 Weingüter wurden beschädigt (allerdings nur weniger als zehn schwer).
                        bedeutet eine reduzierte Produktion für die kommenden Jahre. Der Rauch wird sich natürlich auch auf andere auswirken
                        Kalifornische Weingüter, unabhängig davon, ob sie durch die Brände beschädigt wurden oder nicht. Mehrere
                        Die Weinberge von Sonoma County, darunter Ancient Oak Cellars und Helena View Johnson, wurden schwer getroffen.
                        schlimmer als das benachbarte Napa (obwohl Stag’s Leap davon betroffen war), hauptsächlich aufgrund der feuchteren Lage in Napa
                        Erde, die es den Flammen schwer machte, sich festzusetzen.
                        <br><br>
                        Der Wiederaufbau war für die Weingüter ein mühsamer Prozess, viele von ihnen verloren dabei ihr Zuhause.
                        Doch fast zwei Jahre später kommen die Weingüter langsam aber sicher wieder auf die Beine.
                        Einige produzieren weiterhin mit zugekauften Trauben, andere feiern das Jahr
                        mit speziellen Cuvées, die sich, wie wir vermuten, in den kommenden Jahren als sehr anlegerfreundlich erweisen werden
                        kommen.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Sonoma</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Napa est peut-être la vallée californienne qui fait la une des journaux, mais vous seriez négligent d'ignorer Sonoma
                        Comté lors du développement de votre portefeuille de vins fins. Situé à environ une heure au nord de San Francisco,
                        Le terrain vaste et varié de Sonoma ne peut que signifier de bonnes choses pour l'œnologue du placard. Avec 17
                        Les zones viticoles américaines (AVA) s'étendant sur 20 miles, les vallées de Sonoma et
                        microclimats permet de siroter un rosé chez un vigneron hipster, de déguster un
                        Zinfandel lors d'une visite de l'entrepôt de production, dégustez du Chardonnay directement du fût dans un
                        cave souterraine, ou dégustez des pinots lors d'une dégustation verticale privée.
                        <br><br>
                        Située entre l'océan Pacifique et Napa, Sonoma produit silencieusement presque deux fois plus de vin
                        comme Napa, mais ne génère même pas la moitié du nombre de pouces de colonne. Alors qu'il n'y a pas de gros billet
                        vignobles ici, ce que Sonoma fait incroyablement bien, c'est de produire un niveau constant d'excellents
                        vin rouge corsé. Les climats tempérés varient des plaines ensoleillées aux collines chargées de brouillard,
                        qui représente le spectre des vins disponibles sur le marché secondaire ou avec votre amende
                        marchand de vins.
                        <br><br>
                        Fondée par des frères franciscains lors d'une mission en 1823, l'industrie viticole du comté de Sonoma était
                        destiné à l'origine au vin de communion. Subissant le même sort que ses voisins de Napa pendant
                        Au début du XXe siècle, la viticulture de la région a décliné à moins de 50 établissements vinicoles. Sonoma était
                        plus lent à relever le gant posé par Mondovi et al après l'interdiction et même aussi tard que
                        1960, il y avait moins de 50km2 de vignes plantées dans la vallée. Cependant, comme la consommation de vin
                        a grandi dans les années 1970, tout comme les vignerons entreprenants et en 1999, Sonoma Country comptait 180 inscrits
                        caves. En 2019, ce chiffre était de 250, dont plus de la moitié ont été établis au cours des dernières
                        25 ans.
                        <br><br>
                        Cependant, les incendies de forêt dévastateurs de l'automne 2017 ont vu de nombreux domaines et vignobles
                        complètement disparaître. Propulsées par des vents de 60 mph, les flammes ont englouti plus de 2450 000 acres de
                        terre et fait 43 morts. 1 200 établissements vinicoles ont été endommagés (bien que seulement moins de dix gravement) ce qui
                        signifie une production réduite pour les années à venir. La fumée affectera bien sûr d'autres
                        Les vignobles californiens, qu'ils aient été endommagés ou non par les incendies. Plusieurs
                        Les vignobles du comté de Sonoma, dont Ancient Oak Cellars et Helena View Johnson, ont été durement touchés,
                        pire que la Napa voisine (bien que Stag’s Leap ait été affectée), principalement en raison de la plus humide de Napa
                        sol qui rendait difficile l'adhérence des flammes.
                        <br><br>
                        La reconstruction a été un processus ardu pour les établissements vinicoles, dont beaucoup ont perdu des maisons au cours du processus.
                        Cependant, près de deux ans plus tard et lentement mais sûrement, les domaines se remettent sur pied.
                        Certains ont continué à produire avec des raisins achetés et tandis que d'autres commémorent l'année
                        avec des cuvées spéciales qui, nous le soupçonnons, se révéleront très favorables aux investisseurs dans les années à
                        venir.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Sonoma</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Napa may be the headline-grabbing valley of California but you would be remiss to ignore Sonoma
                        County when developing your fine wine portfolio. Located about an hour north of San Francisco,
                        Sonoma’s vast and varied terrain can only mean good things for the closet oenologist. With 17
                        American Viticultural Areas (AVAs) stretching across 20 miles, Sonoma’s valleys and
                        microclimates means it is possible to sip a rosé at a hipster winemaker’s home, taste a
                        Zinfandel while on a production warehouse tour, sample Chardonnay straight from the barrel in an
                        underground cave, or enjoy Pinots during a private vertical tasting.
                        <br><br>
                        Located between the Pacific Ocean and Napa, Sonoma silently produces almost twice as much wine
                        as Napa, yet generates not even half as many column inches. While there are no big ticket
                        wineries here, what Sonoma does incredibly well is produce a consistent level of excellent
                        full-bodied red wine. Temperate and climate vary from sun-beaten plains to fog-laden hills,
                        which accounts for the spectrum of wines available on the secondary market or with your fine
                        wine retailer.
                        <br><br>
                        Established by Franciscan friars while on a mission in 1823, the Sonoma County wine industry was
                        originally destined for communion wine. Suffering the same fate as its Napa neighbours during
                        the early 20 th century, the region’s winemaking declined to fewer than 50 wineries. Sonoma was
                        slower to pick up the gauntlet laid down by Mondovi et al post-prohibition and even as late as
                        1960, there were under 50km2 of planted vineyard in the valley. However, as wine consumption
                        grew in the 1970s, so did enterprising winemakers and by 1999 Sonoma Country had 180 registered
                        wineries. In 2019 that figure stood at 250, over half of which have been established in the last
                        25 years.
                        <br><br>
                        However, devastating forest fires in the autumn of 2017 saw many estates and vineyards
                        completely disappear. Propelled by 60mph winds, the flames swallowed more than 2450,000 acres of
                        land and claimed 43 lives. 1,200 wineries were damaged (although only under ten severely) which
                        means a reduced production for the years to come. The smoke will, of course, affect other
                        Californian wineries, regardless of whether they were damaged by the fires or not. Several
                        Sonoma County vineyards including Ancient Oak Cellars and Helena View Johnson were hit hard,
                        worse than neighbouring Napa (although Stag’s Leap was affected), mainly due to Napa’s wetter
                        soil that made it hard for the flames to stick.
                        <br><br>
                        Rebuilding has been an arduous process for the wineries, many of whom lost homes in the process.
                        However, almost two years on and slowly but surely the wineries are getting back on their feet.
                        Some have carried on producing with bought in grapes and while others are commemorating the year
                        with special cuvees which will, we suspect, turn out to be very investor friendly in years to
                        come.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Sonoma",
    head: {
        title: 'Sonoma fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the diverse and exquisite flavors of the Sonoma wine region, renowned for its premium wine producers and diverse terroirs. Explore the best of California wine country with a visit to Sonoma.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Ridge Vineyards', src: '/wine-guide/usa/sonoma/ridge-vineyards'},
                {report: 'Sine Qua Non', src: '/wine-guide/usa/sonoma/sine-qua-non'},
                {report: 'Verite Vigneron', src: '/wine-guide/usa/sonoma/verite-vigneron'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
